/**
 * Versão do fluxo de onboarding, gravada junto do estado persistido para que uma
 * instalação antiga seja reconhecível quando o fluxo mudar.
 *
 * Mora AQUI, e não em `lib/onboarding.ts`, porque o único consumidor é o
 * `useAppStore` e ler a constante dali fechava um ciclo de require em runtime:
 * `lib/i18n` → `stores/useAppStore` → `lib/onboarding` → `lib/i18n`. Entrando o
 * bundle por `lib/onboarding`, o store era avaliado com o módulo de onboarding
 * ainda pela metade e nascia com `onboardingVersion: undefined` — silencioso,
 * porque hoje ninguém LÊ esse campo para decidir nada. Este módulo é folha (não
 * importa nada) de propósito: é o que garante que o ciclo não volte.
 */
export const ONBOARDING_VERSION = 3;
